/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { useSelector } from "react-redux";
import { setScheduledTask } from "../../../store/api/tasks/reducer";
import { isEditTaskSelector, tasksSelector } from "../../../store/api/tasks/selector";
import { useStoreDispatch } from "../../../store/hooks";
import { InputField } from "../../Shared/Radix/Inputs/InputField";

interface IProps {
    cellType: string;
}

export const CellEnableDisable: React.FC<IProps> = ({ cellType }) => {
    const dispatch = useStoreDispatch();
    const scheduledtasks = useSelector(tasksSelector);
    const isEditTask = useSelector(isEditTaskSelector);

    const onChangeHandler = (name: string, value: string) => {
        if (name === "idType") {
            if (value === "cellId") {
                dispatch(setScheduledTask({ [name]: value, zoneIdValue: "", cellIdSet: true, zoneIdSet: false, allCell: false }));
            } else if (value === "zoneId") {
                dispatch(setScheduledTask({ [name]: value, cellIdValue: "", cellIdSet: false, zoneIdSet: true, allCell: false }));
            } else if (value === "allCell") {
                dispatch(setScheduledTask({ [name]: value, zoneIdValue: "", cellIdValue: "", cellIdSet: false, zoneIdSet: false, allCell: true }));
            }
        } else if (name === "cellAction") {
            dispatch(setScheduledTask({ [name]: value }));
        } else {
            dispatch(setScheduledTask({ [name]: value }));
        }
    };

    const onRadioChange = (name: string, value: string) => {
        onChangeHandler(name, value);
    };

    const onInputChange = (name: string, value: string) => {
        dispatch(setScheduledTask({ [name]: value }));
    };

    const idTypeValue = scheduledtasks?.allCell ? "allCell" : scheduledtasks?.cellIdSet ? "cellId" : "zoneId";

    return (
        <div className="flex flex-col gap-6">
            <div className={`flex items-center gap-8 ${isEditTask ? "opacity-50 pointer-events-none" : ""}`}>
                {[
                    { value: "Enable", label: `${cellType} Cell Enable` },
                    { value: "Disable", label: `${cellType} Cell Disable` },
                ].map((opt) => (
                    <label key={opt.value} className="flex items-center gap-1.5 cursor-pointer text-sm">
                        <input
                            type="radio"
                            name="cellAction"
                            value={opt.value}
                            checked={scheduledtasks?.cellAction === opt.value}
                            onChange={() => onRadioChange("cellAction", opt.value)}
                            style={{ accentColor: "var(--primary)" }}
                        />
                        {opt.label}
                    </label>
                ))}
            </div>
            <div className="flex flex-col gap-4">
                <div className="flex items-center justify-between">
                    <label className="flex items-center gap-1.5 cursor-pointer text-sm">
                        <input
                            type="radio"
                            name="idType"
                            value="allCell"
                            checked={idTypeValue === "allCell"}
                            onChange={() => onRadioChange("idType", "allCell")}
                            style={{ accentColor: "var(--primary)" }}
                        />
                        All Cells
                    </label>
                </div>
                <div className="flex items-center justify-between">
                    <label className="flex items-center gap-1.5 cursor-pointer text-sm">
                        <input
                            type="radio"
                            name="idType"
                            value="cellId"
                            checked={idTypeValue === "cellId"}
                            onChange={() => onRadioChange("idType", "cellId")}
                            style={{ accentColor: "var(--primary)" }}
                        />
                        Cell ID
                    </label>
                    <div className="w-48">
                        <InputField
                            label=""
                            name="cellIdValue"
                            value={scheduledtasks?.cellIdValue ?? ""}
                            disabled={!scheduledtasks?.cellIdSet}
                            onChange={onInputChange}
                        />
                    </div>
                </div>
                <div className="flex items-center justify-between">
                    <label className="flex items-center gap-1.5 cursor-pointer text-sm">
                        <input
                            type="radio"
                            name="idType"
                            value="zoneId"
                            checked={idTypeValue === "zoneId"}
                            onChange={() => onRadioChange("idType", "zoneId")}
                            style={{ accentColor: "var(--primary)" }}
                        />
                        Zone ID
                    </label>
                    <div className="w-48">
                        <InputField
                            label=""
                            name="zoneIdValue"
                            value={scheduledtasks?.zoneIdValue ?? ""}
                            disabled={!scheduledtasks?.zoneIdSet}
                            onChange={onInputChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}